import { HttpClient, HttpRequest, HttpResponse, HttpHeaders, HttpEventType } from '@angular/common/http';
import { AlertService } from './alert.service';

import { Injector } from '@angular/core';

import { Observable } from 'rxjs';
import { isArray } from 'util';
import { ABaseService } from './a-base.service';

/** Create and execute http requests */
export abstract class BaseHttpService extends ABaseService {
    static URL: string = "";
    private http: HttpClient;
    private alertService: AlertService;
    /**
     * Create a global service to manage http interactions
     * @param injector - injector root service used in app.module
     */
    constructor(injector: Injector) {
        super(injector);
    }

    /**
     * Create a valid HttpRequest
     * @param url - Relative url to access to the api
     * @param method - Http method type
     * @param id - Id of a specific record
     * @param data - Data to send to the server
     */
    protected getRequest(url: string, method: "GET" | "PUT" | "POST" | "PATCH" | "DELETE", id?: any, data?: any): HttpRequest<any> {
        if (!url.startsWith("api")) url = "api/" + url;
        if (id !== undefined && id !== null) url += "/" + id;

        let request: HttpRequest<any> = new HttpRequest<any>(method.toString(), url, data);

        return request;
    }

    /**
     * Execute the given @param request
     * @param request - A valid HttpRequest to execute
     */
    protected executeQuery<T>(request: HttpRequest<any>): Observable<T> {
        var response: Observable<any>;
        if (!this.http) this.http = this._injector.get(HttpClient);

        // Workaround: you need to set the responseType this way in order to avoid the following error:
        // Type '"text" | "arraybuffer" | "blob" | "json"' is not assignable to type '"json"'.
        const options = { headers: request.headers, params: request.params, responseType: request.responseType as 'text' };

        switch (request.method) {
            case "GET":
                response = this.http.get(request.url, options);
                break;
            case "POST":
                response = this.http.post(request.url, request.body, options);
                break;
            case "PUT":
                response = this.http.put(request.url, request.body, options);
                break;
            case "PATCH":
                response = this.http.patch(request.url, request.body, options);
                break;
            case "DELETE":
                response = this.http.delete(request.url, options);
                break;
        }

        return response;
    }

    protected executeRequest(request: HttpRequest<any>): Observable<any> {
        if (!this.http) this.http = this._injector.get(HttpClient);

        return this.http.request(request);
    }

    /**
     * Display an alert for the current error
     * @param error - Error message
     */
    displayError(error: any) {
        var message = error;
        if (message.error) message = message.error;
        if (message instanceof Array) message = message[0];
        if (message.description) message = message.description;
        if (message.message) message = message.message;

        if (typeof message === 'object') message = JSON.stringify(message);

        if (!this.alertService) this.alertService = this._injector.get(AlertService);
        this.alertService.error(message);
    }

    /**
     * Reject the promise with the specified @param error
     * @param error - Error message
     */
    handleError(error: any): Promise<any> {
        this.displayError(error);
        return Promise.reject(error);
    }

    convertToT<T>(type: new () => T, json: any): T | T[] {
        if (isArray(json)) return (json as {}[]).map(i => this.convertToT(type, i) as T);

        const model: T = new type();
        Object.assign(model, json);
        return model;
    }
}
